<div class="flex flex-row justify-center">
  <div class="w-10on12 md-w-full">
    <div class="flex flex-row gap-3 items-center mt-4">
      <button mat-icon-button routerLink="/michelin-stock">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="m-0">Atualizar Estoque Michelin via Excel</h2>
    </div>
    <div class="mt-3 flex flex-col gap-5 w-full">     
      <div class="flex flex-row">
        <mat-form-field class="w-2on6">
          <mat-label>Arquivo excel</mat-label>
          <input
            matInput
            placeholder="Selecione um arquivo"
            value="{{ selectedFile ? selectedFile.item(0).name : null }}"
            (click)="fillFileInput.click()"
            autocomplete="off"
          />
          <input hidden (change)="selectFile($event)" #fillFileInput type="file" id="fillFileInput" autocomplete="off" />
          <mat-hint>Tipo de arquivo: .xlsx, .xls</mat-hint>
          <button mat-icon-button matSuffix color="primary" (click)="fillFileInput.click()">
            <mat-icon>open_in_browser</mat-icon>
          </button>
        </mat-form-field>
        <a mat-button color="primary" class="ml-4 w-100 flex flex-row items-center" style="margin-top: 10px">
          <mat-icon>cloud_download</mat-icon>
          <span>Download Arquivo Modelo</span>
        </a>
      </div>      
    <div class="mt-4">
      <button mat-flat-button color="primary" class="mic-btn-icon-left">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</div>
